// extracted by mini-css-extract-plugin
module.exports = {"contentImg":"index-module_contentImg_JmmC0","large":"index-module_large_1mscr","normal":"index-module_normal_Bq4DA"};